import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Button, Header, Input, Navbar } from "../../../components";
import { LogoMedium } from "../../../components/Images/Images";
import styles from "./ForgotPassword.module.css";
import { authErrorMessages } from "../utils";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const handleSend = async () => {
    setLoading(true);
    const auth = getAuth();
    await sendPasswordResetEmail(auth, email, {url: 'https://bigresume.io/me/login'})
      .then(() => {
        setSuccess(true);
        // Password reset email sent!
      })
      .catch((error) => {
        const errorCode = error.code;
        setError(errorCode);
      });
    setLoading(false);
  };

  return (
    <>
      <div className={styles.forgotPasswordContainer}>
        <img className={styles.logo} src={LogoMedium} />
        <Header
          content="Can't remember your password?"
          subheading="Worry not! we will help you get back into your account. Enter your account email address and we will send you link to reset your password"
        />
        <br />
        {success ? (
          <p className={styles.successMessage}>Password reset email has been sent. Please check your email to reset the password</p>
        ) : (
          <>
            <Input
              label="Account Email"
              placeholder="example@abcd.com"
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <Button
              content="Send Reset Link"
              onClick={handleSend}
              disabled={email == ""}
              loading={loading}
            />

            <p className={styles.errorMessage}>{authErrorMessages[error]}</p>
          </>
        )}
      </div>
    </>
  );
}

export default ForgotPassword;
